module.exports = new __parcel__URL__("shop_machines_neon_gold_mine_v2.f60cc450.png").toString();